<template>
    <li class="monitoringLog">
        <span class="time">{{ time }}</span>
        <span class="error" v-if="data.error > 0">{{ data.error }}</span>
        <span class="message">{{ data.message }}</span>
        <span class="detail">{{ data.detail }}</span>
    </li>
</template>

<script>
export default {
  props: [
    'data'
  ],
  computed: {
    time () { return new Date(this.data.date).toLocaleTimeString() }
  }
}
</script>

<style scoped>
.monitoringLog{
  display:flex;
  flex-wrap:wrap;
  align-items:center
}
.monitoringLog:nth-child(odd){
  background-color:rgba(255,255,255,0.1)
}
.monitoringLog:nth-child(even){
  background-color:rgba(255,255,255,0.2)
}
.monitoringLog span{
  line-height:18px;
  padding:0;
  margin:0
}
.monitoringLog span.time{
  flex:inherit;
  width:60px;
  color:green;
}
.monitoringLog span.error{
  flex:inherit;
  width:15px;
  color:red;
  text-align:center;
}
.monitoringLog span.message{
  flex:1;
  color:white
}
.monitoringLog span.detail{
  align-self:flex-end;
  flex:inherit;
  width:100%;
  display:block;
  color:orange
}
</style>
